const initLoadMore = () => {
    const button = document.querySelector(".load-more-btn");
    const cardDeck = document.querySelector(".card-deck");
    button && cardDeck && button.addEventListener("click", (event) => {
        event.preventDefault();
        if (event.target instanceof HTMLAnchorElement) {
            const clickedButton = event.target;
            //start loading animation
            clickedButton.classList.add("loading");
            const nextPageUrl = event.target.href;
            fetch(`${nextPageUrl}&prt=1`)
                .then(data => {
                //convert the response into plain text
                data.text()
                    //resolve the promise
                    .then((result) => {
                    // Initialize the DOM parser
                    const parser = new DOMParser();
                    // Parse the text and convert it into HTML
                    const parsedHTML = parser.parseFromString(result, "text/html");
                    //get only the cards
                    const cardsToAppendArray = parsedHTML.querySelectorAll(".card");
                    //append them to the deck
                    cardsToAppendArray.forEach(card => {
                        cardDeck.append(card);
                    });
                    //update loadmore link or hide button
                    const updatedButton = parsedHTML.querySelector(".load-more-btn");
                    if (updatedButton != null) {
                        clickedButton.href = updatedButton.href;
                        //stop loading animation
                        clickedButton.classList.remove("loading");
                    }
                    else {
                        //hide load more
                        clickedButton.classList.add("not-visible");
                    }
                });
            });
        }
    });
};
